'use strict';

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var BufferList = require('bl/BufferList');

var _require = require('rabin-wasm'),
    create = _require.create;

var errcode = require('err-code');

module.exports = /*#__PURE__*/function () {
  var _rabinChunker = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source, options) {
    var rabin, min, max, avg, sizepow, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            rabin = jsRabin();

            if (!(options.minChunkSize && options.maxChunkSize && options.avgChunkSize)) {
              _context.next = 7;
              break;
            }

            avg = options.avgChunkSize;
            min = options.minChunkSize;
            max = options.maxChunkSize;
            _context.next = 14;
            break;

          case 7:
            if (options.avgChunkSize) {
              _context.next = 11;
              break;
            }

            throw errcode(new Error('please specify an average chunk size'), 'ERR_INVALID_AVG_CHUNK_SIZE');

          case 11:
            avg = options.avgChunkSize;
            min = avg / 3;
            max = avg + avg / 2;

          case 14:
            if (!(min < 16)) {
              _context.next = 16;
              break;
            }

            throw errcode(new Error('rabin min must be greater than 16'), 'ERR_INVALID_MIN_CHUNK_SIZE');

          case 16:
            if (max < min) {
              max = min;
            }

            if (avg < min) {
              avg = min;
            }

            sizepow = Math.floor(Math.log2(avg));
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 21;
            _iterator = _asyncIterator(rabin(source, {
              min: min,
              max: max,
              bits: sizepow,
              window: options.window,
              polynomial: options.polynomial
            }));

          case 23:
            _context.next = 25;
            return _awaitAsyncGenerator(_iterator.next());

          case 25:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 29;
            return _awaitAsyncGenerator(_step.value);

          case 29:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 37;
              break;
            }

            chunk = _value;
            _context.next = 34;
            return chunk;

          case 34:
            _iteratorNormalCompletion = true;
            _context.next = 23;
            break;

          case 37:
            _context.next = 43;
            break;

          case 39:
            _context.prev = 39;
            _context.t0 = _context["catch"](21);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 43:
            _context.prev = 43;
            _context.prev = 44;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 48;
              break;
            }

            _context.next = 48;
            return _awaitAsyncGenerator(_iterator.return());

          case 48:
            _context.prev = 48;

            if (!_didIteratorError) {
              _context.next = 51;
              break;
            }

            throw _iteratorError;

          case 51:
            return _context.finish(48);

          case 52:
            return _context.finish(43);

          case 53:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[21, 39, 43, 53], [44,, 48, 52]]);
  }));

  function rabinChunker(_x, _x2) {
    return _rabinChunker.apply(this, arguments);
  }

  return rabinChunker;
}();

var jsRabin = function jsRabin() {
  return /*#__PURE__*/function () {
    var _ref = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(source, options) {
      var r, buffers, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, chunk, sizes, i, size, buf;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _awaitAsyncGenerator(create(options.bits, options.min, options.max, options.window));

            case 2:
              r = _context2.sent;
              buffers = new BufferList();
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context2.prev = 6;
              _iterator2 = _asyncIterator(source);

            case 8:
              _context2.next = 10;
              return _awaitAsyncGenerator(_iterator2.next());

            case 10:
              _step2 = _context2.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context2.next = 14;
              return _awaitAsyncGenerator(_step2.value);

            case 14:
              _value2 = _context2.sent;

              if (_iteratorNormalCompletion2) {
                _context2.next = 32;
                break;
              }

              chunk = _value2;
              buffers.append(chunk);
              sizes = r.fingerprint(chunk);
              i = 0;

            case 20:
              if (!(i < sizes.length)) {
                _context2.next = 29;
                break;
              }

              size = sizes[i];
              buf = buffers.slice(0, size);
              buffers.consume(size);
              _context2.next = 26;
              return buf;

            case 26:
              i++;
              _context2.next = 20;
              break;

            case 29:
              _iteratorNormalCompletion2 = true;
              _context2.next = 8;
              break;

            case 32:
              _context2.next = 38;
              break;

            case 34:
              _context2.prev = 34;
              _context2.t0 = _context2["catch"](6);
              _didIteratorError2 = true;
              _iteratorError2 = _context2.t0;

            case 38:
              _context2.prev = 38;
              _context2.prev = 39;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context2.next = 43;
                break;
              }

              _context2.next = 43;
              return _awaitAsyncGenerator(_iterator2.return());

            case 43:
              _context2.prev = 43;

              if (!_didIteratorError2) {
                _context2.next = 46;
                break;
              }

              throw _iteratorError2;

            case 46:
              return _context2.finish(43);

            case 47:
              return _context2.finish(38);

            case 48:
              if (!buffers.length) {
                _context2.next = 51;
                break;
              }

              _context2.next = 51;
              return buffers.slice(0);

            case 51:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[6, 34, 38, 48], [39,, 43, 47]]);
    }));

    return function (_x3, _x4) {
      return _ref.apply(this, arguments);
    };
  }();
};